// src/beta/App.tsx
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BetaRoutes } from '@/beta/routes';
import { BetaErrorBoundary } from '@/beta/hooks/useBetaErrorBoundary';
import '@/beta/styles/beta.css';

const betaQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

/** Beta tree root. Mounted at /beta/* by main.tsx.
 *  - Wraps everything in <div data-vm-beta> so beta.css tokens apply.
 *  - Owns its own QueryClient (legacy app's queries don't see this one).
 *  - Wrapped in error boundary that shows wordmark + legacy fallback link. */
export function BetaApp() {
  return (
    <BetaErrorBoundary>
      <QueryClientProvider client={betaQueryClient}>
        <div data-vm-beta>
          <BetaRoutes />
        </div>
      </QueryClientProvider>
    </BetaErrorBoundary>
  );
}
